import type { Dispatch, RefObject, SetStateAction, UIEvent } from 'react'

import type { ConversationItem } from '@app/models'
import type { ConfigurationState } from '@app/store/configuration'
import {
  closeConversationAndNavigateToMessages,
  getBackUrl,
  isB2BView,
} from '@app/utils'

import type { NavigateFunction } from 'react-router-dom'

export const openParticipantsModalCallback =
  (setModalOpen: Dispatch<SetStateAction<boolean>>) => () => {
    setModalOpen(true)
  }

export const closeParticipantsModalCallback =
  (setModalOpen: Dispatch<SetStateAction<boolean>>) => () => {
    setModalOpen(false)
  }

type FetchMessages = (conversation: ConversationItem) => Promise<void> | void

type ScrollEvent = UIEvent<HTMLDivElement>

export const handleScrollCallback =
  (
    loadingRef: RefObject<boolean>,
    conversation: ConversationItem | null,
    fetchMessages: FetchMessages
  ) =>
    (event: ScrollEvent) => {
      const { scrollTop, clientHeight, scrollHeight } =
      event.currentTarget as HTMLDivElement

      const shouldLoadMore =
      Math.abs(scrollTop) + clientHeight === scrollHeight && !loadingRef.current

      if (shouldLoadMore && conversation && conversation.fetching === 'SUCCEED') {
        fetchMessages(conversation)
      }
    }

export const navigateBackCallback =
  (
    conversationId: number | string | null | undefined,
    navigate: NavigateFunction,
    configuration: ConfigurationState
  ) =>
    (event: Event) => {
      const customEvent = event as CustomEvent<{
      callback?: (result: boolean) => void
    }>
      const doCloseConversation = conversationId != null
      const isBackOffice = isB2BView()

      if (doCloseConversation && conversationId != null) {
        closeConversationAndNavigateToMessages(navigate)
      } else if (isBackOffice) {
        const backUrl = getBackUrl(configuration)
        window.location.href = backUrl
      }

      if (customEvent.detail?.callback) {
        customEvent.detail.callback(isBackOffice || doCloseConversation)
      }
    }
